import styled from 'styled-components';

export const ViewDetailsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  form {
    display: flex;
    &.ant-form .ant-form-item {
      margin-bottom: 0;
      margin-right: 36px;
    }
  }
  & > div {
    cursor: pointer;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  & > div:last-child {
    margin-left: ${({ canDelete }: { canDelete: any }) => canDelete && '20px'};
  }
`;
